var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTdebank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_2500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8365 32 32 24.8365 32 16C32 7.16344 24.8365 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8365 7.16344 32 16 32Z",
    fill: "#8D91AB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3751 19.3405C24.3751 22.3277 21.9174 24.7493 18.8854 24.7493H8.51562V21.1434H18.8854C19.8959 21.1434 20.7153 20.3362 20.7153 19.3405C20.7153 18.3449 19.8959 17.5377 18.8854 17.5377H15.2254V13.9318H18.8854C19.8959 13.9318 20.7153 13.1247 20.7153 12.1289C20.7153 11.1332 19.8959 10.326 18.8854 10.326H8.51562V6.72021H18.8854C21.9174 6.72021 24.3751 9.14178 24.3751 12.1289C24.3751 13.5142 23.8467 14.7778 22.9774 15.7348C23.8467 16.6917 24.3751 17.9553 24.3751 19.3405Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.51562 6.72021C13.5689 6.72021 17.6654 10.7562 17.6654 15.7348C17.6654 20.7133 13.5689 24.7493 8.51562 24.7493V21.1434C11.5476 21.1434 14.0055 18.722 14.0055 15.7348C14.0055 12.7476 11.5476 10.326 8.51562 10.326V6.72021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_2500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdebank);
export default __webpack_public_path__ + "static/media/tdebank.f1280eaabaeec88ec2d3854af80931f6.svg";
export { ForwardRef as ReactComponent };